import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { Company } from './Company.js';
/**
 * Who is paying / paid, and how can we contact them
 */
export class PaymentCustomer extends AutoEncoder {
    firstName = null;
    lastName = null;
    email = null;
    phone = null;
    /**
     * As soon as this is set, we can assume that the customer is a company
     */
    company = null;
    get name() {
        if (this.firstName && this.lastName) {
            return `${this.firstName} ${this.lastName}`;
        }
        return this.firstName || this.lastName;
    }
    get dynamicName() {
        if (this.company) {
            return this.company.name || this.company.companyNumber || $t(`%ma`);
        }
        if (this.firstName && this.lastName) {
            return `${this.firstName} ${this.lastName}`;
        }
        return this.firstName || this.lastName || this.email || this.phone || $t(`%mb`);
    }
    get dynamicEmail() {
        return this.email || this.company?.administrationEmail || null;
    }
    equals(other) {
        if (this.firstName !== other.firstName) {
            return false;
        }
        if (this.lastName !== other.lastName) {
            return false;
        }
        if (this.email !== other.email) {
            return false;
        }
        if (this.phone !== other.phone) {
            return false;
        }
        if (!!this.company !== !!other.company) {
            return false;
        }
        if (this.company && other.company) {
            if (!this.company.equals(other.company)) {
                return false;
            }
        }
        return true;
    }
}
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], PaymentCustomer.prototype, "firstName", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], PaymentCustomer.prototype, "lastName", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], PaymentCustomer.prototype, "email", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], PaymentCustomer.prototype, "phone", void 0);
__decorate([
    field({ decoder: Company, nullable: true })
], PaymentCustomer.prototype, "company", void 0);
//# sourceMappingURL=PaymentCustomer.js.map